var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3327 0.833374H2.33268C1.41185 0.833374 0.666016 1.57921 0.666016 2.50004V14.1667H2.33268V2.50004H12.3327V0.833374ZM14.8327 4.16671H5.66602C4.74518 4.16671 3.99935 4.91254 3.99935 5.83337V17.5C3.99935 18.4209 4.74518 19.1667 5.66602 19.1667H14.8327C15.7535 19.1667 16.4993 18.4209 16.4993 17.5V5.83337C16.4993 4.91254 15.7535 4.16671 14.8327 4.16671ZM14.8327 17.5H5.66602V5.83337H14.8327V17.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.64f58298abed45c15d36ddf674ab2635.svg";
export { ForwardRef as ReactComponent };